/**
 * ACCESS
 */

//Display modal "under construction"  upon link click
export const isDevelopmentModalActive = document.querySelector('html').getAttribute('data-development-modal');

/**
 * GDPR
 */
export const gdprDuration = 60;


/**
 * WHERE TO BUY
 */
export const WhereToBuyConstants = {
  distances_difuzo: (document.querySelector('[name="where_to_buy_distance_list_option"]') ?  document.querySelector('[name="where_to_buy_distance_list_option"]').value.split(',').map(element => element.trim()) : ''),
  iconOpacityDefault: 1,
  iconOpacityHover: 0.75,
  panPath: [],
  panQueue: [],
  STEPS: 15,
  maxZoom: 17,
  minZoom: 3,
  DISTANCE_MAX: 20000,
  animationDelay: 4000,
  animationBaseDuration: 750,
  basePinWidth: 84,
  basePinHeight: 80,
  md5_image_logo_url : "https://cdn02.fortin.ca/images.d/md5/raw/",
  url_place_photo_placeholder : "https://dummyimage.com/320x180/cccccc/7a7a7a.png&text=",
  url_logo_placeholder : "https://dummyimage.com/160x90/cccccc/7a7a7a.png&text=",
  noLogoHash: "791003175f5630bf77644e15c3e91a20",
  map_id: (document.querySelector('#map') == null) ? "": document.querySelector('#map').getAttribute('data-gm-map-id'),
  url_installator: "/ajax/points_of_sales.php",
  url_distributor: "/ajax/distributors.php",
  icons: {
    pin_business: {
      icon: "/dist/images/temp/where-to-buy/pin-business--hover.svg",
      icon_hover: "/dist/images/temp/where-to-buy/pin-business--hover.svg"
    },
    shipping_truck: {
      icon: "/dist/images/temp/where-to-buy/Shipping_truck.svg"
    },
    dealer: {
      icon: "/dist/images/temp/where-to-buy/Dealer.svg"
    },
    gold_medal: {
      icon: "/dist/images/temp/where-to-buy/gold-medal.svg"
    },
    platinum_medal: {
      icon: "/dist/images/temp/where-to-buy/platinum-medal.svg"
    },
    phone: {
      icon: "/dist/images/temp/where-to-buy/ic_phone.svg"
    },
    remote: {
      icon: "/dist/images/temp/where-to-buy/Box_Remote_RM942.svg"
    },
    back_arrow: {
      icon: "/dist/images/temp/where-to-buy/back-arrow.svg"
    },
    location: {
      icon: "/dist/images/temp/where-to-buy/mylocation.png"
    }
  },
  states: {
    en: {"AB":"Alberta","BC":"British Columbia","MB":"Manitoba","NB":"New Brunswick","NL":"Newfoundland","NT":"Northwest Territories","NS":"Nova Scotia","NU":"Nunavut","ON":"Ontario","PE":"Prince Edward Island","QC":"Quebec","SK":"Saskatchewan","YT":"Yukon Territory"},
    fr: {"AB":"Alberta","BC":"Colombie-Britannique","MB":"Manitoba","NB":"Nouveau-Brunswick","NS":"Nouvelle-\u00c9cosse","NU":"Nunavut","ON":"Ontario","QC":"Qu\u00e9bec","SK":"Saskatchewan","NL":"Terre-Neuve","NT":"Territoires du Nord-Ouest","YT":"Yukon","PE":"\u00cele-du-Prince-\u00c9douard"}
  }
};

WhereToBuyConstants.usData = {
  "side-menu": {
    "types": {
      "title": "What are you looking for?",
        "checkboxes": {
        'second': "Authorized distributors (B2B)",
          'third': "Product and Installation Centers",
      }
    },
    "types2": {
      "title": "Filters",
        "checkboxes": {
        'second': "Full-Line In-Stock",
          'third': "Online Reseller",
      }
    },
    "territories": {
      "title": "available territories",
        "boxes": {
        'first': {
          "title": "international distribution",
            "description": "Outside Canada and the United States? \nContact us to discuss international distribution options.",
            "button": {
            "text": "contact international sales",
              "href": "#"
          }
        },
        'second': {
          "title": "american distribution",
            "description": "Inside Canada or the United States?\nContact us to discuss about distribution opportunities and pricing.",
            "button": {
            "text": "contact sales in america",
              "href": "#"
          }
        }
      }
    },
    "back": "<img src=" + WhereToBuyConstants.icons.back_arrow.icon + "> back"
  },
  "map": {
    "locateme": "Use my location"
  }
};
WhereToBuyConstants.data = {
  "side-menu": {
    "types": {
      "title": "What are you looking for?",
        "checkboxes": {
        'second': "Authorized distributors (B2B)",
          'third': "Product and Installation Centers",
      }
    },
    "types2": {
      "title": "Filters",
        "checkboxes": {
        'second': "Full-Line In-Stock",
          'third': "Online Reseller",
      }
    },
    "territories": {
      "title": "available territories",
        "boxes": {
        'first': {
          "title": "international distribution",
            "description": "Outside Canada and the United States? \nContact us to discuss international distribution options.",
            "button": {
            "text": "contact international sales",
              "href": "#"
          }
        },
        'second': {
          "title": "american distribution",
            "description": "Inside Canada or the United States?\nContact us to discuss about distribution opportunities and pricing.",
            "button": {
            "text": "contact sales in america",
              "href": "#"
          }
        }
      }
    },
  },
};

// Cdn const

export const cdn_url = document.querySelector('html').getAttribute('data-cdn-domain');
